import { isConnectionComingSoon } from "@/config/connectionAvailability";
import { FEATURE_FLAGS } from "@/config/featureFlags";
import { isConnectionValidationAccount } from "@/config/connectionValidation";
import { useLibraryIdentity } from "@/hooks/useLibraryIdentity";

/** UI rollout only; the file executor still validates account, scopes and approval. */
export function useFileConnectionAccess() {
  const identity = useLibraryIdentity();
  const validationAccount = isConnectionValidationAccount(identity);
  return {
    googleDriveEnabled: FEATURE_FLAGS.GOOGLE_DRIVE_ENABLED || validationAccount,
    oneDriveEnabled: !isConnectionComingSoon("onedrive") && (FEATURE_FLAGS.ONEDRIVE_ENABLED || validationAccount),
    filesEnabled: FEATURE_FLAGS.FILES_EXECUTOR_ENABLED || validationAccount,
    // Notion's existing import stays unchanged until its file rollout is enabled.
    notionEnabled: FEATURE_FLAGS.FILES_EXECUTOR_ENABLED,
    identityKey: identity.ready && !identity.error
      ? identity.userId ?? "signed-out"
      : "unresolved",
  };
}
